<template>
  <div class="ai-generating-animation">
    <div class="animation-container">
      <!-- Block 1 -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 1" 
          src="@/assets/MyWorkBench/Workflow/block1.svg" 
          alt="" 
          class="block block-1"
        />
      </transition>

      <!-- Line 1 -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 2" 
          src="@/assets/MyWorkBench/Workflow/line1.svg" 
          alt="" 
          class="line line-1"
        />
      </transition>

      <!-- Block 2 -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 3" 
          src="@/assets/MyWorkBench/Workflow/block2.svg" 
          alt="" 
          class="block block-2"
        />
      </transition>

      <!-- Line 2 -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 4" 
          src="@/assets/MyWorkBench/Workflow/line2.svg" 
          alt="" 
          class="line line-2"
        />
      </transition>

      <!-- Block 3 (left) -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 5" 
          src="@/assets/MyWorkBench/Workflow/block3.svg" 
          alt="" 
          class="block block-3"
        />
      </transition>

      <!-- Block 4 (right) -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 6" 
          src="@/assets/MyWorkBench/Workflow/block4.svg" 
          alt="" 
          class="block block-4"
        />
      </transition>

      <!-- Line 3 -->
      <transition name="fade-scale">
        <img 
          v-if="visibleItems >= 7" 
          src="@/assets/MyWorkBench/Workflow/line3.svg" 
          alt="" 
          class="line line-3"
        />
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIGeneratingAnimation',
  data() {
    return {
      visibleItems: 0,
      animationInterval: null
    };
  },
  mounted() {
    this.startAnimation();
  },
  beforeUnmount() {
    this.stopAnimation();
  },
  methods: {
    startAnimation() {
      this.animationInterval = setInterval(() => {
        if (this.visibleItems < 7) {
          this.visibleItems++;
        } else {
          this.visibleItems = 0;
        }
      }, 600);
    },
    stopAnimation() {
      if (this.animationInterval) {
        clearInterval(this.animationInterval);
        this.animationInterval = null;
      }
    }
  }
};
</script>

<style scoped>
.ai-generating-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.animation-container {
  position: relative;
  width: 327.039px;
  height: 418.879px;
}

/* Blocks and Lines */
.block,
.line {
  position: absolute;
}

/* Vue Transition Classes */
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: opacity 0.6s ease-in-out, transform 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.fade-scale-enter-from,
.fade-scale-leave-to {
  opacity: 0;
  transform: scale(0.85);
}

.fade-scale-enter-to,
.fade-scale-leave-from {
  opacity: 1;
  transform: scale(1);
}

/* Block Positions */
.block-1 {
  left: 99.68px;
  top: 0;
  width: 127.68px;
  height: 96.319px;
}

.block-2 {
  left: 99.68px;
  top: 154.56px;
  width: 127.68px;
  height: 103.042px;
}

.block-3 {
  left: 12px;
  top: 313.84px;
  width: 127.68px;
  height: 103.04px;
}

.block-4 {
  left: 179.36px;
  top: 313.84px;
  width: 127.68px;
  height: 103.04px;
}

/* Line Positions */
.line-1 {
  left: 155.68px;
  top: 95.2px;
  width: 15.68px;
  height: 60.48px;
}

.line-2 {
  left: 69.84px;
  top: 255.6px;
  width: 99.68px;
  height: 58.24px;
}

.line-3 {
  left: 153.52px;
  top: 257.6px;
  width: 99.68px;
  height: 58.24px;
}
</style>
